export default __webpack_public_path__ + "static/media/ambiente.099e3848.png";